<template>
  <!-- 学生单项训练统计页面 -->
  <div class="xueShengDanXiangXunLian">
    <div class="student_training_left" :style="'height:'+(height-90)+'px'">
      <div class="encourage_words">
        <p>{{famousQuotesData.content}}—{{famousQuotesData.author}}</p>
      </div>
      <div class="course_task_progress">
        <h2>课程任务进度<span>完成任务<i>{{taskProgressData.finishTaskNum}}个</i>/ 总任务<i>{{taskProgressData.totalTaskNum}}个</i></span></h2>
        <div class="course_task_progress_left">
          <el-progress :stroke-width="7" :percentage="taskProgressData.progress"></el-progress>
        </div>
        <div class="course_task_progress_right">
          <p><span><i>{{taskProgressData.sort}}</i>/{{taskProgressData.studentNum}}</span>班级排名</p>
          <img src="../../../../../../../static/images/study/statistics/ranking.png" alt="">
        </div>
      </div>
<!--      <div class="study_length">-->
<!--        <h2>-->
<!--          <span>累计学习时长</span>-->
<!--          <img src="../../../../../../../static/images/study/statistics/time.png" alt="">-->
<!--          <p>{{learnTime | filterTime}}</p>-->
<!--        </h2>-->
<!--      </div>-->
      <div class="post_statistics">
				<div class="top_title">
					<h2>分岗位正确率统计</h2>
					<div class="level_list">
						<ul>
							<li>
								<i></i><span>优秀（80%-100%）</span>
							</li>
							<li>
								<i></i><span>良好（60%-79%）</span>
							</li>
							<li>
								<i></i><span>中等（40%-59%）</span>
							</li>
							<li>
								<i></i><span>待加强（0%-39%）</span>
							</li>
						</ul>
					</div>
				</div>
        <ul class="progress_list" v-if="postAccuracyStatisticsData.length>0">
          <li v-for="(item, i) in postAccuracyStatisticsData" :key="i">
            <el-progress type="circle" :percentage="item.weights?Math.ceil(item.weights*100) : 0" :color="item.color" :format="format"></el-progress>
            <p>{{item.postName}}</p>
          </li>
        </ul>
        <div v-else class="no_data">
          <img src="../../../../../../../static/images/wujieguo.png" alt="">
          <p>暂无统计结果</p>
        </div>
      </div>
      <div class="notes_and_discuss">
        <div class="notes_wrap">
          <h2>笔记</h2>
          <div class="note_details">
            <img src="../../../../../../../static/images/study/statistics/note.png" alt="">
            <div>
              <b>{{noteData.noteNum?noteData.noteNum:'0'}}条</b>
              <p>公开笔记数</p>
            </div>
          </div>
        </div>
        <div class="discuss_wrap">
          <h2>讨论</h2>
          <ul>
            <li>
              <img src="../../../../../../../static/images/study/statistics/theme.png" alt="">
              <div>
                <b>{{discussData.themeNum?discussData.themeNum:'0'}}条</b>
                <p>发表主题数</p>
              </div>
            </li>
            <li>
              <img src="../../../../../../../static/images/study/statistics/reply.png" alt="">
              <div>
                <b>{{discussData.replyNum?discussData.replyNum:'0'}}条</b>
                <p>回复主题数</p>
              </div>
            </li>
            <li>
              <img src="../../../../../../../static/images/study/statistics/comment.png" alt="">
              <div>
                <b>{{discussData.commentNum?discussData.commentNum:'0'}}条</b>
                <p>发表评论数</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="test_wrap" v-if="isTestData">
        <h2>测验</h2>
        <div class="broken_line_diagram" v-if="testChartData.rows.length>1">
          <div class="test_top">
            <div class="test_left">
              <ve-line
                :data="testChartData"
                :extend="testExtend"
                :colors="testColors"
                :legend-visible="false"
                :data-empty="testDataEmpty"
                width="100%"
                height="350px">
              </ve-line>
              <ul>
                <li><span>我的分数</span><i></i></li>
                <li><span>班级最高分</span><i></i></li>
                <li><span>班级平均分</span><i></i></li>
              </ul>
            </div>
            <!-- <div class="test_right">
              <div class="test_right_top">
                <p>75分</p>
                <p>历次测验平均分</p>
              </div>
              <ul>
                <li><span>我的分数</span><i></i></li>
                <li><span>班级最高分</span><i></i></li>
                <li><span>班级平均分</span><i></i></li>
              </ul>
            </div> -->
          </div>
          <div class="test_bot">
            <div class="test_bot_left">
              <h2>平均分</h2>
              <div class="test_bot_left_box">
                <p>{{testAvgScore}}分</p>
                <p>历次测验平均分</p>
              </div>
            </div>
            <div class="test_bot_right">
              <h2>排名</h2>
              <ul>
                <li v-for="(item,i) in testDataList" :key="i">
                  <p>
                    <span v-if="item.sort">第{{item.sort}}名</span>
                    <span v-else>未提交</span>
                    （提交{{item.num}}人）</p>
                  <p :title="item.paperName">{{item.paperName}}</p>
                  <!-- <img src="../../../../../../../static/images/study/statistics/arrow.png" alt="" @click="testJump(item)"> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="single_test_diagram" v-else>
          <!-- <span class="view_details">查看详情<i></i></span> -->
          <div>
            <p>{{singleTestData.paperName}}</p>
            <p>班级排名：<span>第{{singleTestData.sort?singleTestData.sort:singleTestData.num}}名</span>（提交{{singleTestData.num}}人）</p>
          </div>
          <ul>
            <li>
              <el-progress type="circle" :percentage="singleTestData.score" color="#03D57C"></el-progress>
              <span>{{singleTestData.score}}分</span>
              <p>我的分数</p>
            </li>
            <li>
              <el-progress type="circle" :percentage="singleTestData.maxScore" color="#FF6464"></el-progress>
              <span>{{singleTestData.maxScore}}分</span>
              <p>班级最高分</p>
            </li>
            <li>
              <el-progress type="circle" :percentage="singleTestData.avgScore" color="#B95AFF"></el-progress>
              <span>{{singleTestData.avgScore}}分</span>
              <p>班级平均分</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="student_training_right" :style="'height:'+(height-90)+'px'">
      <h2>学习轨迹</h2>
      <el-timeline class="timeline_ul" v-if="activities.length>0">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.timestamp" placement="top">
          <div class="timeline_card">
            <p>{{activity.content}}</p>
            <!-- <i></i> -->
            <img v-if="activity.type=='1'" :src="picture"/>
            <img v-else-if="activity.type=='2'" :src="file"/>
            <img v-else-if="activity.type=='3'" :src="audio"/>
            <img v-else-if="activity.type=='4'" :src="video"/>
            <img v-else-if="activity.type=='5'" :src="zip"/>
            <img v-else-if="activity.type=='6'" :src="question"/>
            <img v-else-if="activity.type=='7'" :src="paper"/>
            <img v-else-if="activity.type=='8'" :src="file"/>
            <img v-else-if="activity.type=='9'" :src="file"/>
            <img v-else-if="activity.type=='10'" :src="file"/>
            <img v-else-if="activity.type=='11'" :src="file"/>
            <img v-else :src="file"/>
          </div>
        </el-timeline-item>
      </el-timeline>
      <div v-else class="no_data">
        <img src="../../../../../../../static/images/wujieguo.png" alt="">
        <p>暂无学习轨迹</p>
      </div>
    </div>
  </div>
</template>
<script>
  /**
   *  学生单项训练统计页面
   */
  import * as api from '../../../../../../api/statisticsApi'
export default {
  data() {
    this.chartSettings = {
      stack: { '用户': ['访问人数'] },
      area: true,
      itemStyle:{ //面积图颜色设置
        color:{
          type:'linear',
          x:0,
          y:0,
          x2:0,
          y2:1,
          colorStops:[
            {
              offset: 0,
              color: 'rgba(83,151,247,0.8)',
            },
            {
              offset: 1,
              color: 'rgba(255,255,255,1)'
            },
          ],
          globalCoord: false
        }
      },
    }
    this.testExtend = {
      yAxis: {
        type: 'value',
        max: 100,
        min: 0
      },
      series: {
        label: {
          normal: {
            show: true
          }
        }
      }
    }
    return {
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      userId: sessionStorage.getItem('userId'),
      height: window.innerHeight,
      activities: [],
      chartData: {
        columns: ['时间', '访问人数'],
        rows: [
          { '时间': '1/1', '访问人数': 393 },
          { '时间': '1/2', '访问人数': 530 },
          { '时间': '1/3', '访问人数': 223 },
          { '时间': '1/4', '访问人数': 423 },
          { '时间': '1/5', '访问人数': 192 },
          { '时间': '1/6', '访问人数': 593 }
        ]
      },
      colors: ['#5397F7'],
      testChartData: {
        columns: ['名称', '我的分数', '班级最高分', '班级平均分'],
        rows: []
      },
      testColors: ['#03D57C','#FF6464','#B95AFF'],
      testDataList:[],
      testAvgScore: '',//平均分
      testDataEmpty: false,
      isTestData: false,
      singleTestData: {// 单个测验数据
        paperName: '',
        sort: '',
        num: '',
        score: 0,
        maxScore: 0,
        avgScore: 0
      },
      taskProgressData: {
        finishTaskNum: 0,
        totalTaskNum: 0,
        progress: 0,
        resourceTypeDtos: [],
        sort: 0,
        studentNum: 0
      },
      averageHeight: 80,
      noteData: {//笔记
        noteNum: ''
      },
      discussData: {//讨论
        themeNum: 0,
        replyNum: 0,
        commentNum: 0
      },
      postAccuracyStatisticsData: [],//分岗位正确统计率
      postAccuracyColor: ['#5397F7', '#FD785A', '#FECB61', '#34D3B0'],
      picture: '../../../../../../../static/images/study/sourceIcon/picture.png',
      video: '../../../../../../../static/images/study/sourceIcon/video.png',
      audio: '../../../../../../../static/images/study/sourceIcon/audio.png',
      zip: '../../../../../../../static/images/study/sourceIcon/zip.png',
      file: '../../../../../../../static/images/study/sourceIcon/file.png',
      paper: '../../../../../../../static/images/study/sourceIcon/paper.png',
      question: '../../../../../../../static/images/study/sourceIcon/question.png',
      famousQuotesData: {
        content: '',
        author: ''
      },
      learnTime: '',//累计学习时长
    }
  },
  filters: {
    typeStatus(type) {
      switch (type) {
        case 1:
          return "图片";
        case 2:
          return "文档";
        case 3:
          return "音频";
        case 4:
          return "视频";
        case 5:
          return "zip";
        case 6:
          return "实操";
        case 7:
          return "测验";
        case 8:
          return "笔记";
        case 9:
          return "发布讨论";
        case 10:
          return "回复讨论";
        case 11:
          return "评论讨论";
        default:
          return "实操";
          break;
      }
    },
    filterTime(minutes){
      return (Math.floor(minutes/60) + " 小时 " + (minutes%60) + " 分钟" );
    }
  },
  mounted(){
    this.getFamousQuotes()
    this.getTaskProgress()
    this.getPostData()
    this.getTestChart()
    this.getAvgScore()
    this.getNotesNum()
    this.getDiscussNum()
    this.getSourceList()
    // this.getLearnTimeStudent()//累计学习时长
  },
  methods: {
    format(percentage) {
      return percentage === 100 ? '满' : `${percentage}分`;
    },
    getFamousQuotes(){//心灵鸡汤
      api.getFamousQuotes().then(rs=>{
        if(rs.status==1){
          this.famousQuotesData = {
            content: rs.content,
            author: rs.author
          }
        }else{
          this.$messageError(rs)
        }
      })
    },
    getTaskProgress(){//课程任务进度
      let that = this
      api.getTaskProgress(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          that.taskProgressData = {
            finishTaskNum: rs.data.finishTaskNum,
            totalTaskNum: rs.data.totalTaskNum,
            progress: Number((rs.data.progress * 100).toFixed(2)),
            resourceTypeDtos: rs.data.resourceTypeDtos,
            sort: rs.data.sort?rs.data.sort:rs.data.studentNum,
            studentNum: rs.data.studentNum
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getPostData(){//分岗位正确统计率
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "userId": sessionStorage.getItem('userId')
      }
      api.getStudentPostData(obj).then(rs=>{
        if(rs.code==0){
          this.postAccuracyStatisticsData = rs.data;
					this.postAccuracyStatisticsData.forEach(item=>{
						let val = item.weights ? Math.ceil((item.weights?item.weights:0)*100) : 0;
						if(val<=100 && val>=80){ //优秀
							item.color = this.postAccuracyColor[3]
						}else if(val<=79 && val>=60){ //良好
							item.color = this.postAccuracyColor[0]
						}else if(val<=59 && val>=40){ //中等
							item.color = this.postAccuracyColor[2]
						}else if(val<=39 && val>=0){ //待加强
							item.color = this.postAccuracyColor[1]
						}
					})
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
		format(percentage){
			if(percentage<=100 && percentage>=80){ //优秀
				return '优秀';
			}else if(percentage<=79 && percentage>=60){ //良好
				return '良好';
			}else if(percentage<=59 && percentage>=40){ //中等
				return '中等';
			}else if(percentage<=39 && percentage>=0){ //待加强
				return '待加强';
			}
		},
    getTestChart(){//测验图表
      let that = this
      api.getTestChart(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          that.testChartData.rows = []
          that.testDataList = []
          if(rs.data.length>0){
            if(rs.data.length>1){
              rs.data.forEach(v=>{
                let obj = {
                  '名称': v.paperName,
                  '我的分数': v.score!=null ? v.score : 0,
                  '班级最高分': v.maxScore,
                  '班级平均分': v.avgScore
                }
                that.testChartData.rows.push(obj)
              })
              rs.data.forEach(v=>{
                let obj = {
                  'sort': v.sort,
                  'num': v.num,
                  'paperName': v.paperName
                }
                that.testDataList.push(obj)
              })
            }else{
              this.singleTestData = {
                paperName: rs.data[0].paperName,
                sort: rs.data[0].sort,
                num: rs.data[0].num,
                score: rs.data[0].score?rs.data[0].score:0,
                maxScore: rs.data[0].maxScore?rs.data[0].maxScore:0,
                avgScore: rs.data[0].avgScore?rs.data[0].avgScore:0
              }
            }
            that.testDataEmpty = false
            that.isTestData = true
          }else{
            that.testDataEmpty = true
            // that.isTestData = false
            that.getTestListAll()
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getTestListAll(){
      let that = this
      api.getTestListAll(this.courseId).then(rs=>{
        if(rs.code==0){
          if(rs.data.length>0){
            if(rs.data.length>1){
              rs.data.forEach(v=>{
                let obj = {
                  '名称': v.paperName,
                  '我的分数': v.score!=null ? v.score : 0,
                  '班级最高分': v.maxScore,
                  '班级平均分': v.avgScore
                }
                that.testChartData.rows.push(obj)
              })
              rs.data.forEach(v=>{
                let obj = {
                  'sort': v.sort,
                  'num': v.num,
                  'paperName': v.paperName
                }
                that.testDataList.push(obj)
              })
            }else{
              this.singleTestData = {
                paperName: rs.data[0].paperName,
                sort: rs.data[0].sort,
                num: rs.data[0].num,
                score: rs.data[0].score?rs.data[0].score:0,
                maxScore: rs.data[0].maxScore?rs.data[0].maxScore:0,
                avgScore: rs.data[0].avgScore?rs.data[0].avgScore:0
              }
            }
            that.testDataEmpty = false
            that.isTestData = true
          }else{
            that.isTestData = false
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getAvgScore(){//测验平均分
      api.getAvgScore(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.testAvgScore = (rs.data?rs.data:'0')
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getNotesNum(){//笔记
      api.getNotesNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.noteData.noteNum = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getDiscussNum(){//讨论
      let that = this
      api.getDiscussNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          rs.data.forEach(v=>{
            if(v.type==0){
              that.discussData.themeNum = v.num
            }
            if(v.type==1){
              that.discussData.replyNum = v.num
            }
            if(v.type==2){
              that.discussData.commentNum = v.num
            }
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getSourceList(){//学习轨迹
      let that = this
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "pageNo": 1,
        "pageSize": 30
      }
      api.getSourceList(obj).then(rs=>{
        this.activities = []
        if(rs.code==0){
          rs.data.list.forEach(v=>{
            let obj = {
              content: that.resourceType(v.resourceType),
              timestamp: that.formatTime(v.learnDate),
              color: '#5397F7',
              type: String(v.resourceType)
            }
            that.activities.push(obj)
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    testJump(item){//测验跳转
      console.log(item)
    },
    formatTime(time) {
      return (time = time.slice(0, 10) + " " + time.slice(11, 19));
    },
    resourceType(type){
      switch (type) {
        case 1:
          return "您查看了1张图片";
        case 2:
          return "您阅读完了1份文档";
        case 3:
          return "您听完了1个音频";
        case 4:
          return "您观看完了1个视频";
        case 5:
          return "您阅读完了1份文档";
        case 6:
          return "您完成了1个实操任务";
        case 7:
          return "您完成了1个测验";
        case 8:
          return "您发布了1条笔记";
        case 9:
          return "您发布了1条讨论";
        case 10:
          return "您回复了1条讨论";
        case 11:
          return "您评论了1条讨论";
        default:
          return "其他";
          break;
      }
    },
    getLearnTimeStudent(){
      api1.getLearnTimeStudent(this.courseId,this.classId,this.userId).then(rs=>{
        if(rs.code==0){
          this.learnTime = rs.data.learnTime
        }else{
          this.$messageError(rs.msg)
        }
      })
    }
  },
}
</script>
<style lang="scss">
  .xueShengDanXiangXunLian{
    .student_training_left{
      width: calc(100% - 272px);
      margin: 16px;
      float: left;
      overflow-y: auto;
      .encourage_words{
        width: 100%;
        height: 40px;
        background: url('../../../../../../../static/images/study/statistics/encourage-bg.png') no-repeat;
        background-size: 100% 100%;
        p{
          font-size:16px;
          line-height:40px;
          color:rgba(51,51,51,1);
          margin-left: 24px;
        }
      }
      .course_task_progress{
        height:120px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        margin: 16px 0;
        position: relative;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
          span{
            font-size:12px;
            font-weight:400;
            color:#333333;
            margin-left: 16px;
            i{
              color: #5397F7;
              margin-left: 5px;
            }
          }
        }
        .course_task_progress_left{
          width: 65%;
          margin-left: 24px;
          margin-top: 35px;
          .el-progress__text{
            font-size:12px !important;
            font-weight:400;
            color:rgba(83,151,247,1);
            margin-left: 20px;
          }
        }
        .course_task_progress_right{
          position: absolute;
          right: 33px;
          top: 28px;
          width:240px;
          height:64px;
          background:rgba(255,178,60,1);
          box-shadow:0px 3px 6px rgba(0,0,0,0.16);
          border-radius:4px;
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(255,255,255,1);
            margin-left: 20px;
            margin-top: 10px;
            span{
              font-size: 24px;
              margin-right: 5px;
              i{
                font-size: 45px;
                font-style: normal;
                color: #fff;
              }
            }
          }
          img{
            width: 48px;
            height: 48px;
            position: absolute;
            right: 15px;
            top: 10px;
          }
        }
      }
      .study_length{
        height: 50px;
        background:rgba(255,255,255,1);
        border-radius: 4px;
        display: flex;
        margin-bottom: 16px;
        h2{
          height: 50px;
          display: flex;
          align-items: center;
          span{
            font-size:16px;
            font-weight:600;
            color:rgba(51,51,51,1);
            padding-left: 24px;
          }
          img{
            width: 24px;
            height: 24px;
            margin-left: 32px;
            margin-right: 16px;
          }
          p{
            font-size: 16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 5px;
          }
        }
      }
      .post_statistics{
        height:252px;
        background:rgba(255,255,255,1);
        border-radius:4px;
				.top_title {
					display: flex;
					justify-content: start;
					padding-top: 16px;
					.level_list {
						ul {
							margin-left: 50px;
							display: flex;
							justify-content: start;
							li {
								display: flex;
								justify-content: start;
								align-items: center;
								margin-right: 20px;
								i {
									display: inline-block;
									width: 30px;
									height: 10px;
									background: #34D3B0;
									margin-right: 10px;
								}
								span {
									font-size: 12px;
								}
								&:nth-child(2) {
									i {
										background: #5397F7;
									}
								}
								&:nth-child(3) {
									i {
										background: #FECB61;
									}
								}
								&:nth-child(4) {
									i {
										background: #FD785A;
									}
								}
							}
						}
					}
				}
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 0 0 0 24px;
        }
        .progress_list {
          display: flex;
          width: 80%;
          justify-content: space-around;
          margin: 33px 10% 0;
          /deep/ li{
            width: 115px;
            text-align: center;
            p{
              margin-top: 18px;
              font-size:14px;
              line-height:19px;
              color:rgba(51,51,51,1);
            }
            .el-progress-circle{
              width: 115px !important;
              height: 115px !important;
            }
          }
        }
      }
      .notes_and_discuss{
        height: 160px;
        margin: 16px 0;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        .notes_wrap{
          width:268px;
          height:160px;
          background:rgba(250,252,253,1);
          border-radius:4px;
          float: left;
          .note_details{
            width:220px;
            height:80px;
            background:rgba(255,255,255,1);
            box-shadow:0px 3px 6px rgba(0,0,0,0.16);
            border-radius:4px;
            display: flex;
            align-items: center;
            margin: 16px 0 0 24px;
            img{
              width: 56px;
              height: 56px;
              margin-left: 32px;
              margin-right: 16px;
            }
            div{
              b{
                font-size:24px;
                font-weight:400;
                color:rgba(51,51,51,1);
              }
              p{
                font-size:14px;
                color:rgba(153,153,153,1);
                margin-top: 10px;
              }
            }
          }
        }
        .discuss_wrap{
          width:calc(100% - 284px);
          height:160px;
          background:rgba(255,255,255,1);
          opacity:1;
          border-radius:4px;
          margin-left: 16px;
          float: right;
          ul{
            margin: 16px 16px 0 24px;
            display: flex;
            justify-content: space-between;
            li{
              width:220px;
              height:80px;
              background:rgba(255,255,255,1);
              box-shadow:0px 3px 6px rgba(0,0,0,0.16);
              border-radius:4px;
              display: flex;
              align-items: center;
              img{
                width: 56px;
                height: 56px;
                margin-left: 32px;
                margin-right: 16px;
              }
              div{
                b{
                  font-size:24px;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                }
                p{
                  font-size:14px;
                  color:rgba(153,153,153,1);
                  margin-top: 10px;
                }
              }
            }
          }
        }
      }
      .test_wrap{
        background:rgba(255,255,255,1);
        border-radius:4px;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        .broken_line_diagram{
          position: relative;
          .test_left{
            width: calc(100% - 80px);
            margin-left: 24px;
            float: left;
            .data-empty {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(255, 255, 255, .7);
              color: #888;
              font-size: 14px;
            }
            ul{
              display: flex;
              position: absolute;
              right: 20px;
              top:-20px;
              li{
                height: 33px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 40px;
                span{
                  width:70px;
                  font-size:14px;
                  color:rgba(51,51,51,1);
                  text-align: right;
                  margin-right: 12px;
                }
                i{
                  width:32px;
                  height:4px;
                }
                &:nth-child(1){
                  i{
                    background: #03D57C;
                  }
                }
                &:nth-child(2){
                  i{
                    background: #FF6464;
                  }
                }
                &:nth-child(3){
                  i{
                    background: #B95AFF;
                  }
                }
              }
            }
          }
          .test_right{
            width:241px;
            height:293px;
            border:1px solid rgba(235,235,235,1);
            border-radius:4px;
            float: right;
            margin-right: 24px;
            padding: 33px 25px;
            box-sizing: border-box;
            .test_right_top{
              width:192px;
              height:80px;
              background:rgba(52,211,176,1);
              border-radius:4px;
              padding: 15px 0 0 46px;
              box-sizing: border-box;
              p{
                color: #fff;
                &:first-child{
                  font-size: 24px;
                  position: relative;
                  &::after{
                    content: '';
                    width: 32px;
                    height: 1px;
                    position: absolute;
                    bottom: -3px;
                    left: 0;
                    background: #fff;
                  }
                }
                &:last-child{
                  font-size:14px;
                  color:rgba(255,255,255,1);
                  margin-top: 8px;
                }
              }
            }
            ul{
              margin-top: 30px;
              li{
                height: 33px;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                  width:70px;
                  font-size:14px;
                  color:rgba(51,51,51,1);
                  text-align: right;
                  margin-right: 12px;
                }
                i{
                  width:107px;
                  height:4px;
                }
                &:nth-child(1){
                  i{
                    background: #03D57C;
                  }
                }
                &:nth-child(2){
                  i{
                    background: #FF6464;
                  }
                }
                &:nth-child(3){
                  i{
                    background: #B95AFF;
                  }
                }
              }
            }
          }
          .test_bot{
            clear: both;
            display: flex;
            .test_bot_left{
              h2{
                font-size:16px;
                font-weight:600;
                color:rgba(51,51,51,1);
                padding: 16px 0 0 24px;
              }
              .test_bot_left_box{
                width:140px;
                height:80px;
                background:rgba(52,211,176,1);
                border-radius:4px;
                box-sizing: border-box;
                margin-left: 24px;
                margin-right: 20px;
                margin-top: 16px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;;
                p{
                  width: 90px;
                  text-align: left;
                  color: #fff;
                  &:first-child{
                    font-size: 24px;
                    position: relative;
                    &::after{
                      content: '';
                      width: 32px;
                      height: 1px;
                      position: absolute;
                      bottom: -3px;
                      left: 0;
                      background: #fff;
                    }
                  }
                  &:last-child{
                    font-size:12px;
                    color:rgba(255,255,255,1);
                    margin-top: 8px;
                  }
                }
              }
            }
            .test_bot_right{
              h2{
                font-size:16px;
                font-weight:600;
                color:rgba(51,51,51,1);
                padding: 16px 0 0 0;
              }
              ul{
                margin-top: 16px;
                display: flex;
                flex-wrap: wrap;
                li{
                  width:160px;
                  height:80px;
                  background:rgba(83,151,247,1);
                  border-radius:4px;
                  margin-bottom: 20px;
                  margin-right: 20px;
                  padding-left: 14px;
                  box-sizing: border-box;
                  position: relative;
                  p{
                    font-size: 12px;
                    color: #fff;
                    &:nth-child(1){
                      margin-top: 21px;
                      margin-bottom: 14px;
                    }
                    &:nth-child(2){
                      width: 100px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    span{
                      font-size: 14px;
                    }
                  }
                  img{
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    right: 12px;
                    bottom: 16px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
        .single_test_diagram{
          position: relative;
          height: 268px;
          .view_details{
            font-size: 12px;
            cursor: pointer;
            color: #5397F7;
            margin-left: 8px;
            position: absolute;
            right: 46px;
            top: -15px;
            i{
              display: inline-block;
              width: 8px;
              height: 8px;
              margin-left: 5px;
              background: url('../../../../../../../static/images/newLoginPage/icon2.png') no-repeat;
              background-size: 100%;
            }
          }
          div{
            text-align: center;
            p{
              &:first-child{
                font-size:16px;
                font-weight:400;
                color:rgba(51,51,51,1);
              }
              &:last-child{
                font-size:12px;
                font-weight:400;
                color:#999999;
                margin-top: 8px;
                span{
                  color: #F43D3D;
                }
              }
            }
          }
          ul{
            display: flex;
            width: 60%;
            justify-content: space-around;
            margin: 33px 20% 0;
            li{
              text-align: center;
              position: relative;
              p{
                font-size:14px;
                line-height:19px;
                color:rgba(51,51,51,1);
                margin-top: 14px;
              }
              .el-progress-circle{
                width: 115px !important;
                height: 115px !important;
              }
              span{
                position: absolute;
                left: 0;
                right: 0;
                top: 27px;
                background: #fff;
                width: 70px;
                height: 70px;
                line-height: 70px;
                margin: auto;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    .student_training_right{
      width:240px;
      background:rgba(255,255,255,1);
      border-radius:4px 0px 0px 4px;
      margin-top: 16px;
      float: right;
      overflow-y: auto;
      h2{
        font-size:16px;
        font-weight:600;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
      }
      .timeline_ul{
        margin: 12px 16px 0 20px;
        .el-timeline-item__wrapper{
          padding-left: 16px;
        }
        .timeline_card{
          width:188px;
          height:36px;
          background:rgba(242,247,255,1);
          border-radius:4px;
          display: flex;
          align-items: center;
          cursor: pointer;
          position: relative;
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin: 0 4px 0 12px;
          }
          i{
            width: 8px;
            height: 8px;
            background: url('../../../../../../../static/images/study/statistics/icon.png') no-repeat;
            background-size: 100% 100%;
          }
          img{
            width: 24px;
            height: 24px;
            position: absolute;
            right: 15px;
            top: 6px;
          }
          &:hover{
            // p{
            //   color: #5397F7;
            // }
            i{
              background: url('../../../../../../../static/images/study/statistics/icon1.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .no_data{
      text-align: center;
      img{
        width: 100px;
        margin-top: 50px;
      }
      p{
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/student/studentTraining.vue